import {
  Alert,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";

import {
  LOAN_GUARANTEE_CHEQUE_GUARANTOR_ALERT,
  LOAN_GUARANTEE_CHEQUE_INTENT,
  LOAN_GUARANTEE_CHEQUE_INTENT_HELP,
  loanGuaranteeChequeIntentOptions,
} from "./loanGuaranteeChequeIntentConstants";
import LoanGuarantorInlineFields from "./LoanGuarantorInlineFields";

const LoanGuaranteeChequeIntentSelector = ({
  value = "",
  onChange,
  error = "",
  touched = false,
  disabled = false,
  formValues = null,
  formErrors = null,
  formTouched = null,
  setFieldValue = null,
  setFieldTouched = null,
  showGuarantorFields = true,
}) => {
  const showGuarantor =
    showGuarantorFields &&
    String(value) === LOAN_GUARANTEE_CHEQUE_INTENT.GuarantorWithSayadCheque;

  return (
    <Stack spacing={1.25}>
      <FormControl
        component="fieldset"
        error={Boolean(touched && error)}
        disabled={disabled}
        fullWidth
      >
        <FormLabel component="legend" sx={{ mb: 0.5, fontWeight: 700 }}>
          وضعیت چک صیادی برای وام
        </FormLabel>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {LOAN_GUARANTEE_CHEQUE_INTENT_HELP}
        </Typography>
        <RadioGroup
          value={value == null ? "" : String(value)}
          onChange={(e) => onChange?.(e.target.value)}
        >
          {loanGuaranteeChequeIntentOptions.map((opt) => (
            <FormControlLabel
              key={opt.value}
              value={opt.value}
              control={<Radio size="small" />}
              label={opt.label}
            />
          ))}
        </RadioGroup>
        {touched && error ? <FormHelperText>{error}</FormHelperText> : null}
      </FormControl>

      {showGuarantor ? (
        <>
          <Alert severity="info" variant="outlined">
            {LOAN_GUARANTEE_CHEQUE_GUARANTOR_ALERT}
          </Alert>
          {formValues && setFieldValue ? (
            <LoanGuarantorInlineFields
              values={formValues}
              errors={formErrors || {}}
              touched={formTouched || {}}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              disabled={disabled}
            />
          ) : null}
        </>
      ) : null}
    </Stack>
  );
};

LoanGuaranteeChequeIntentSelector.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  error: PropTypes.string,
  touched: PropTypes.bool,
  disabled: PropTypes.bool,
  formValues: PropTypes.object,
  formErrors: PropTypes.object,
  formTouched: PropTypes.object,
  setFieldValue: PropTypes.func,
  setFieldTouched: PropTypes.func,
  showGuarantorFields: PropTypes.bool,
};

export default LoanGuaranteeChequeIntentSelector;
